import * as React from 'react';
import { Field } from 'formik';

import InputField from '@buyside/components/presentation/Form/Field/InputField/inputField';
import EducationAutocomplete from '@buyside/components/presentation/UserProfileShowPage/UserProfileForm/EducationForm/EducationAutocomplete/educationAutocomplete';

const { degreeTypes, collegeMajors } = require('buyside/util/constantsFromRails.json');
import { AllFormikProps } from '@interfaces/userApplication/userApplication';

import styles from '../pageStyles.scss';

export type StudentProps = Pick<AllFormikProps, 'setFieldValue'>;

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from
// const range = (start, stop, step) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + (i * step));
// SHK 7/16/19
const currentYear = new Date().getFullYear();
const yearStartedOptions = Array.from({ length: 13 }, (_, i): number => currentYear - 12 + i);
const expectedGraduationYearOptions = Array.from({ length: 13 }, (_, i): number => currentYear + i);

const Student: React.FunctionComponent<StudentProps> = ({ setFieldValue }): React.ReactElement => (
  <>
    <h4>Tell us about your educational background.</h4>
    <div className={styles.inputField}>
      <EducationAutocomplete
        analyticsTag="application-student-institution"
        name="schoolName"
        overrideDefault
        placeholder="Begin Typing..."
        setFieldValue={setFieldValue}
      />
    </div>
    <div className={styles.inputFieldHalf} data-heap="application-student-degree">
      <Field
        component={InputField}
        label="Degree"
        name="degree"
        options={[...degreeTypes.undergrad, ...degreeTypes.graduate]}
        type="select"
      />
    </div>
    <div className={styles.inputFieldHalf} data-heap="application-student-major">
      <Field
        component={InputField}
        label="Field of Study"
        name="fieldOfStudy"
        options={collegeMajors}
        type="select"
      />
    </div>
    <div className={styles.inputFieldHalf} data-heap="application-student-year-started-school">
      <Field
        component={InputField}
        label="Year Started"
        name="yearStart"
        options={yearStartedOptions}
        type="select"
      />
    </div>
    <div className={styles.inputFieldHalf} data-heap="application-student-expected-graduation-year">
      <Field
        component={InputField}
        label="Expected Graduation Year"
        name="expectedGraduation"
        options={expectedGraduationYearOptions}
        type="select"
      />
    </div>
  </>
);

export default Student;
